import { PERMISSION_MODULES, PERMISSION_MODULES_DEFAULT } from "../types";
import strings from "translate/language";
import { unAuthorizedError } from "utils/httpClient";
import permissionService from "../service/permissionService";
import { MENUITEMS } from "menuConstant/menu";
import { handleListResponse } from "utils/utils";
import {
  closing_head_id,
  ClosingManager,
  ClosingTL,
  ClusterHead,
  CSTL,
  SCM,
  SourcingHead,
  SourcingTL,
} from "../../utils/constants";

const checkPermission = (data, isAdmin, role_id, isMIS) => {
  let headTeam = ClusterHead === role_id;

  let CTM = [closing_head_id, ClosingManager, ClosingTL];
  const dispositionReportRoles = [...CTM, CSTL, SCM];
  let STM = [SourcingTL, SourcingHead];

  const sideBarList = [
    ...Array.from(
      [...handleListResponse(data), ...MENUITEMS]
        .reduce((m, o) => m.set(o.slug, o), new Map())
        .values()
    ),
  ].map((itm) => ({
    ...handleListResponse(data).find((item) => item.slug === itm.slug && item),
    ...itm,
  }));

  let finalList = sideBarList.map((item) => {
    if (item.slug) {
      if (handleListResponse(data).some((i) => i.slug === item.slug)) {
        item.permission = true;
        item.active = false;
        if (item.module_title === "Closing Manager" && headTeam) {
          item.title = "Closing TL";
        } else if (item.module_title === "Sourcing Manager" && headTeam) {
          item.title = "Sourcing TL";
        } else {
          item.title = item.module_title;
        }
      } else {
        if (isAdmin) {
          if (
            item.slug === "sourcing_manager" ||
            item.slug === "closing_manager" ||
            item.slug === "appointment_ site_visit" ||
            item.slug === "appointment_with_cp" ||
            item.slug === "project_details_report" ||
            item.slug === "cancel_booking" ||
            item.slug === "dispositionReport" ||
            item.slug === "getChannelPartnerAppointments" ||
            item.slug === "scheduled_activity" ||
            item.isAdmins
          ) {
            item.permission = false;
          }
          if (isMIS) {
            if (
              // item.slug === "sourcing_manager" ||
              // item.slug === "closing_manager" ||
              // item.slug === "appointment_ site_visit" ||
              // item.slug === "appointment_with_cp" ||
              // item.slug === "project_details_report" ||
              // item.slug === "cancel_booking" ||
              // item.slug === "dispositionReport" ||
              // item.slug === "getChannelPartnerAppointments" ||
              item.slug === "dashboard1" ||
              item.slug === "configuration_management" ||
              item.slug === "user_management" ||
              item.slug === "role_management" ||
              item.slug === "module_management" ||
              item.slug === "master_management" ||
              item.slug === "booking_management" ||
              item.slug === "user_announcement" ||
              item.slug === "support" ||
              item.slug === "support_forum" ||
              item.slug === "property_management" ||
              item.slug === "channel_management" ||
              item.slug === "followup_management" ||
              item.slug === "registration_management" ||
              item.slug === "master_management"
            ) {
              item.permission = false;
            }
          }
        } else {
          // OLD CODE (commented out for potential revert):
          // item.permission = false;
          
          // NEW CODE: Role-specific permission handling
          if (
            item.slug === "dispositionReport" &&
            dispositionReportRoles.includes(role_id)
          ) {
            item.permission = true;
            item.active = false;
          } else if (item.slug === "report" && role_id === CSTL) {
            item.permission = true;
            item.active = false;
          } else if (
            item.slug === "getChannelPartnerAppointments" &&
            STM.includes(role_id)
          ) {
            item.permission = true;
            item.active = false;
          } else {
            item.permission = false;
          }
        }
      }
    }
    return item;
  });
  return finalList.sort(function (a, b) {
    if (a.title) {
      var _a = a.title === "Dashboard" ? 0 : a.sequence;
      var _b = b.title === "Dashboard" ? 0 : b.sequence;
      return Number(_a) - Number(_b);
    }
  });
};
export const getPermission = (item) => async (dispatch) => {
  try {
    const res = await permissionService.permissionModule(item);
    if (res.data.status === 200) {
      let payload = {
        data: await checkPermission(
          res.data.data,
          item.isAdmin,
          item.role_id,
          item.isMIS
        ),
        isAdmin: item.isAdmin,
      };
      dispatch({
        type: PERMISSION_MODULES,
        payload: payload,
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const removePermission = (item) => async (dispatch) => {
  try {
    dispatch({
      type: PERMISSION_MODULES,
      payload: null,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
